// import { MultipalIcons } from "assets/icons/index";
import { Button } from "components/Button";
import PropTypes from "prop-types";
import {
  ButtonStyleContainer,
  IntroductionContainer,
} from "./SnaptradeModal.styles";

const StepIntroduction = ({ show, onHide, onNext }) => {
  return (
    <IntroductionContainer show={show} onHide={onHide}>
      <div className="content-wrapper m-3">
        {/* <div className="multipal-icons">
          <img src={MultipalIcons} alt="multipal Ions" />
        </div> */}
        <h2>Link your portfolio to Surmount</h2>
        <p>
          Securely connect your investment accounts to Surmount to view, manage,
          and optimize your investments from one platform. Surmount analyzes
          your holdings and, when enabled, can make updates to help keep your
          portfolio aligned with your goals. You remain in control at all times.
        </p>

        <ButtonStyleContainer>
          <Button size="large" onClick={onNext} width="50%">
            Next Step
          </Button>
        </ButtonStyleContainer>
      </div>
    </IntroductionContainer>
  );
};

StepIntroduction.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onNext: PropTypes.func,
};

export default StepIntroduction;
